export default {
	en: {
		custom: {
			shippingAddress: {
				regex: () => 'Please enter your Postal code'
			}
		}
	},


	th: {
		custom: {
			shippingAddress: {
				regex: () => 'กรุณากรอกรหัสไปรษณีย์'
			}
		}
	}

	// Validator.localize('en', dict);
	// // or use the instance method
	// this.$validator.localize('en', dict);
}